import * as wjcCore from 'wijmo/wijmo';
// angular
import {Injectable} from '@angular/core';

// libs
import {Store, Action} from '@ngrx/store';
import {Effect, Actions, ofType} from '@ngrx/effects';
import {map, switchMap} from "rxjs/internal/operators";
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';

import {LotasConfig} from "../../config/lotas.config";

// module
import {DataService} from '@cosbeni/database';
import {ActionTypes, LoadFiscalsAction, LoadFiscalsFailureAction, LoadFiscalsSuccessAction} from "../actions/fiscals.action";

@Injectable()
export class FiscalsEffects {

    @Effect() loadUser$: Observable<Action> = this.actions$.pipe(
        ofType(ActionTypes.LOAD_FISCALS),
        switchMap((state: any) => {
            return this.dataService.query({
                sql: "SELECT id FROM LOTAS_Setting WHERE state = '" + state.payload + "' AND category = 'fiscal' ORDER BY id DESC",
                fetchPlan: "*:0",
            }, LotasConfig.SERVER_URL).map((data) => {
                let fiscals = data.results.map(item => item.id);
                return new LoadFiscalsSuccessAction(fiscals);
            }).catch(() => {
                    return Observable.of(new LoadFiscalsFailureAction())
                }
            );
        })
    )

    constructor(private store: Store<any>,
                private actions$: Actions,
                private dataService: DataService) {
    }
}
